import { render, staticRenderFns } from "./AffinityEdit.vue?vue&type=template&id=3cb6c4f2&scoped=true&"
import script from "./AffinityEdit.vue?vue&type=script&lang=ts&"
export * from "./AffinityEdit.vue?vue&type=script&lang=ts&"
import style0 from "./AffinityEdit.vue?vue&type=style&index=0&id=3cb6c4f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb6c4f2",
  null
  
)

export default component.exports